import type { StatusDispositivo, TipoDispositivoLeitura } from '../../types/models';

export const TIPO_LEITOR: { value: TipoDispositivoLeitura; label: string; hint: string }[] = [
  { value: 'RFID', label: 'RFID / cartão', hint: 'Leitora de cartão ou tag' },
  { value: 'QR_CODE', label: 'QR Code', hint: 'Câmera ou leitor óptico' },
  { value: 'BIOMETRIA', label: 'Biometria', hint: 'Digital ou facial' },
  { value: 'CATRACA', label: 'Catraca', hint: 'Giro ou torniquete' },
  { value: 'MANUAL', label: 'Registro manual', hint: 'Operador na recepção' },
  { value: 'APP', label: 'Aplicativo', hint: 'Tablet ou celular da escola' },
];

export const TIPO_LABEL: Record<TipoDispositivoLeitura, string> = Object.fromEntries(
  TIPO_LEITOR.map(({ value, label }) => [value, label]),
) as Record<TipoDispositivoLeitura, string>;

export const STATUS_LABEL: Record<StatusDispositivo, string> = {
  ONLINE: 'Online',
  OFFLINE: 'Offline',
  MANUTENCAO: 'Manutenção',
  FALHA: 'Falha',
  INATIVO: 'Inativo',
};

export function statusAccent(status: StatusDispositivo, ativo: boolean): string {
  if (!ativo) return '#94a3b8';
  const map: Partial<Record<StatusDispositivo, string>> = {
    ONLINE: '#059669',
    OFFLINE: '#64748b',
    MANUTENCAO: '#d97706',
    FALHA: '#dc2626',
    INATIVO: '#94a3b8',
  };
  return map[status] ?? '#64748b';
}
